module.exports = __webpack_public_path__ + "media/donate/shared/trust_logos/itz-da85245e0ef13c007b82d9b2123094c7.svg";